var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurePaymentIcon2 = function SvgSecurePaymentIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "m7.167.667 6.081 1.9a.83.83 0 0 1 .585.796v1.47H15.5a.833.833 0 0 1 .833.834v6.667a.834.834 0 0 1-.833.833h-2.683c-.323.426-.715.8-1.167 1.11l-4.483 3.057-4.484-3.057A5 5 0 0 1 .5 10.145V3.363a.83.83 0 0 1 .585-.795zm0 1.745-5 1.563v6.17a3.33 3.33 0 0 0 1.298 2.641l.158.114 3.544 2.417 3.151-2.15H6.333a.833.833 0 0 1-.833-.833V5.667a.833.833 0 0 1 .833-.833h5.834v-.859zm0 6.588v2.5h7.5V9zm0-1.666h7.5V6.5h-7.5z"
  })));
};
export default SvgSecurePaymentIcon2;